/* tslint:disable */
require('./NameRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_ba189d58',
  relative: 'relative_ba189d58',
  signalField: 'signalField_ba189d58',
  fabricIcon: 'fabricIcon_ba189d58',
  signal: 'signal_ba189d58',
  newItem: 'newItem_ba189d58',
  newIcon: 'newIcon_ba189d58',
  signalFieldValue: 'signalFieldValue_ba189d58',
  value: 'value_ba189d58',
};

export default styles;
/* tslint:enable */